import styled from 'styled-components';

const CCPAFormWrapper = styled.div`
  .ot-cookie-setting-btn {
    width: 295px;
    margin: 45px auto 0 auto;
    height: 45px;

    p {
      margin: 0;
      position: absolute;
      bottom: 0;
      color: var(--titan-blue-3);
    }

    &:hover {
      cursor: pointer;
    }
  }

  .ot-sdk-show-settings {
    color: transparent !important;
    background: transparent;
    border: none !important;
    width: 295px !important;
    position: absolute !important;
    bottom: -6px !important;

    &:hover {
      background: none !important;
    }
  }
`;

const CCPAFormContainer = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  padding: 32px 28px 66px;
  background: var(--white);
  box-shadow: 0px 15px 40px rgba(0, 0, 0, 0.1);

  .ccpa-form--header {
    max-width: 685px;
    display: flex;
    margin: 10px auto 24px;
    justify-content: space-between;

    .ccpa-form--description {
      text-align: right;
      color: var(--grey-8);
      margin: 0;
    }
  }

  .ccpa-form--form-success {
    font-size: var(--font-size-p-md);
    color: var(--titan-blue-4);
    visibility: hidden;
    height: 0;
    margin: 0;

    &.success-visible {
      visibility: visible;
      margin: 0 0 20px;
      height: auto;
    }
  }

  .ccpa-form--form {
    max-width: 685px;
    margin: 0 auto;

    .additional-dropdown-info {
      margin: -15px 0 25px 0;
      color: var(--neutral-5);
    }

    .show {
      display: block;
    }

    .hide {
      display: none;
    }

    .ccpa-form--form-item {
      margin-bottom: 39px;

      .text-field-helper {
        display: none !important;
      }

      textarea {
        border-radius: 0px !important;
        font-size: var(--font-size-20) !important;
        padding: 10px 23px;
      }
    }
  }

  @media (max-width: 767px) {
    padding: 24px;

    .ccpa-form--form-success {
      font-size: var(--font-size-p);
    }

    .ccpa-form--form {
      max-width: 552px;

      .additional-dropdown-info {
        margin: -5px 0 25px 0;
      }

      .ccpa-form--form-item {
        margin-bottom: 24px;

        textarea {
          font-size: var(--font-size-16) !important;
        }
      }

      .ccpa-form--submit-button {
        width: 100%;
      }
    }
  }

  @media (max-width: 575px) {
    padding: 20px 24px;
  }
`;

export { CCPAFormContainer, CCPAFormWrapper };
